import { render, staticRenderFns } from "./QuotationGradesTable.vue?vue&type=template&id=61187ed2"
import script from "./QuotationGradesTable.vue?vue&type=script&lang=js"
export * from "./QuotationGradesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports